(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const setup = (root) => {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';

      const viewport = root.querySelector('.brand-strip__viewport');
      const track = root.querySelector('[data-brand-track]');
      const group = root.querySelector('[data-brand-group]');
      if (!viewport || !track || !group) return;

      const evaluate = () => {
        // Clean any previous clone
        track.querySelectorAll('[data-brand-clone]').forEach((el) => el.remove());
        root.classList.remove('is-marquee');

        // Measure
        const viewportWidth = viewport.clientWidth;
        const groupWidth = group.scrollWidth;
        if (groupWidth > viewportWidth + 4) {
          const clone = group.cloneNode(true);
          clone.setAttribute('data-brand-clone', '1');
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
          root.classList.add('is-marquee');
        }
      };

      evaluate();

      let resizeId;
      window.addEventListener('resize', () => {
        clearTimeout(resizeId);
        resizeId = setTimeout(evaluate, 150);
      });

      // Re-evaluate when images load (logos size unknown at first paint)
      group.querySelectorAll('img').forEach((img) => {
        if (img.complete) return;
        img.addEventListener('load', evaluate, { once: true });
        img.addEventListener('error', evaluate, { once: true });
      });

      // Pause marquee while user is interacting (touch / mouse scroll)
      let scrollPauseId;
      viewport.addEventListener('touchstart', () => root.classList.add('is-touched'), { passive: true });
      viewport.addEventListener('touchend', () => {
        clearTimeout(scrollPauseId);
        scrollPauseId = setTimeout(() => root.classList.remove('is-touched'), 1500);
      }, { passive: true });
      viewport.addEventListener('scroll', () => {
        root.classList.add('is-scrolling');
        clearTimeout(scrollPauseId);
        scrollPauseId = setTimeout(() => root.classList.remove('is-scrolling'), 1000);
      }, { passive: true });
    };

    const init = () => {
      document.querySelectorAll('[data-brand-strip]').forEach(setup);
    };

    window.__brandStripInit = init;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    const init = () => {
      const form = document.querySelector('[data-cart-form]');
      if (!form || form.dataset.bound) return;
      form.dataset.bound = '1';

      const root = window.Shopify?.routes?.root || '/';

    const formatMoney = (cents, currency) => {
      const _p = (Math.round(cents) / 100).toFixed(2).split('.');
      const _e = _p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return (currency || '€') + _e + ',' + _p[1];
    };

      const setLoading = (key, state) => {
        const el = form.querySelector('[data-cart-item][data-key="' + CSS.escape(key) + '"]');
        if (el) el.classList.toggle('is-loading', state);
      };

      const refreshHeaderCount = (count) => {
        const headerCart = document.querySelector('.site-header__cart');
        if (!headerCart) return;
        let counter = headerCart.querySelector('.site-header__cart-count');
        if (count > 0) {
          if (!counter) {
            counter = document.createElement('span');
            counter.className = 'site-header__cart-count';
            headerCart.appendChild(counter);
          }
          counter.textContent = count;
        } else if (counter) {
          counter.remove();
        }
      };

      const refreshCart = async () => {
        const cartRes = await fetch(`${root}cart.js`, { headers: { 'Accept': 'application/json' } });
        const cart = await cartRes.json();
        refreshHeaderCount(cart.item_count);

        if (cart.item_count === 0) {
          window.location.reload();
          return;
        }

        const symbol = (window.__cartCurrency || '').trim();
        const subtotalEl = form.querySelector('[data-cart-subtotal]');
        const totalEl = form.querySelector('[data-cart-total]');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price, symbol);
        if (totalEl) totalEl.textContent = formatMoney(cart.total_price, symbol);

      if (window.srLivraisonPanier) window.srLivraisonPanier(cart.total_price, cart.item_count);

        cart.items.forEach((item) => {
          const row = form.querySelector('[data-cart-item][data-key="' + CSS.escape(item.key) + '"]');
          if (!row) return;
          const linePrice = row.querySelector('[data-cart-line-price]');
          if (linePrice) linePrice.textContent = formatMoney(item.final_line_price, symbol);
          const qtyInput = row.querySelector('[data-cart-qty-input]');
          if (qtyInput) qtyInput.value = item.quantity;
        });

        const presentKeys = new Set(cart.items.map((i) => i.key));
        form.querySelectorAll('[data-cart-item]').forEach((row) => {
          if (!presentKeys.has(row.getAttribute('data-key'))) row.remove();
        });

        const countEl = document.querySelector('.cart__count');
        if (countEl) {
          const tpl = window.__cartCountTpl || '__COUNT__ items';
          countEl.textContent = tpl.replace('__COUNT__', cart.item_count);
        }
      };

      const updateLine = async (key, quantity) => {
        setLoading(key, true);
        try {
          const res = await fetch(`${root}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: key, quantity }),
          });
          if (!res.ok) throw new Error('change failed');
          await refreshCart();
        } catch (err) {
          console.error(err);
        } finally {
          setLoading(key, false);
        }
      };

      form.addEventListener('click', (e) => {
        const removeBtn = e.target.closest('[data-cart-remove]');
        if (removeBtn) {
          e.preventDefault();
          updateLine(removeBtn.getAttribute('data-cart-remove'), 0);
          return;
        }
        const qtyBtn = e.target.closest('[data-cart-qty]');
        if (qtyBtn) {
          e.preventDefault();
          const key = qtyBtn.getAttribute('data-key');
          const delta = parseInt(qtyBtn.getAttribute('data-cart-qty'), 10);
          const input = form.querySelector('[data-cart-qty-input][data-key="' + CSS.escape(key) + '"]');
          if (!input) return;
          const next = Math.max(0, (parseInt(input.value, 10) || 1) + delta);
          input.value = next;
          updateLine(key, next);
        }
      });

      form.addEventListener('change', (e) => {
        const input = e.target.closest('[data-cart-qty-input]');
        if (!input) return;
        const key = input.getAttribute('data-key');
        const next = Math.max(0, parseInt(input.value, 10) || 0);
        updateLine(key, next);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-filtered"] && !Shopify.designMode) return;
  try {
    

  /* Street Ride : description de collection repliable */
  (function () {
    if (window.__srClampLoaded) return;
    window.__srClampLoaded = true;
    var init = function () {
      document.querySelectorAll('[data-sr-clamp]').forEach(function (el) {
        if (el.dataset.srClampBound) return;
        el.dataset.srClampBound = '1';
        var btn = el.nextElementSibling;
        if (!btn || !btn.hasAttribute('data-sr-clamp-toggle')) return;
        el.classList.add('is-clamped');
        if (el.scrollHeight > el.clientHeight + 4) {
          btn.hidden = false;
        } else {
          el.classList.remove('is-clamped');
        }
      });
    };
    window.__srClampInit = init;
    {
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-sr-clamp-toggle]');
        if (!btn) return;
        var el = btn.previousElementSibling;
        if (!el) return;
        var open = el.classList.toggle('is-clamped') === false;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? btn.dataset.less : btn.dataset.more;
      });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    if (window.MutationObserver) {
      var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(init, 60); }).observe(document.documentElement, { childList: true, subtree: true });
    }
  })();
  /* ---- Drawer / sort: event delegation (survives AJAX swaps) ---- */
  (function () {
    if (document.body.dataset.cfilterDelegated) return;
    document.body.dataset.cfilterDelegated = '1';

    document.addEventListener('click', (e) => {
      const openBtn = e.target.closest('[data-cfilter-open]');
      if (openBtn) {
        const sidebar = document.querySelector('[data-cfilter-sidebar]');
        if (sidebar) sidebar.classList.add('is-open');
        return;
      }
      const closeBtn = e.target.closest('[data-cfilter-close]');
      if (closeBtn) {
        const sidebar = document.querySelector('[data-cfilter-sidebar]');
        if (sidebar) sidebar.classList.remove('is-open');
        return;
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const sidebar = document.querySelector('[data-cfilter-sidebar]');
        if (sidebar && sidebar.classList.contains('is-open')) {
          sidebar.classList.remove('is-open');
        }
      }
    });

    document.addEventListener('change', (e) => {
      const select = e.target.closest('[data-cfilter-sort]');
      if (!select) return;
      const form = document.querySelector('#cfilter-form');
      if (form) form.submit();
    });
  })();

  (function () {
    const init = () => {

      document.querySelectorAll('[data-price-range]').forEach((wrapper) => {
        if (wrapper.dataset.cfilterBound) return;
        wrapper.dataset.cfilterBound = '1';

        const minInput = wrapper.querySelector('[data-price-slider="min"]');
        const maxInput = wrapper.querySelector('[data-price-slider="max"]');
        const minDisplay = wrapper.querySelector('[data-price-display="min"]');
        const maxDisplay = wrapper.querySelector('[data-price-display="max"]');
        const minHidden = wrapper.querySelector('[data-price-hidden="min"]');
        const maxHidden = wrapper.querySelector('[data-price-hidden="max"]');
        const fill = wrapper.querySelector('[data-price-fill]');
        const floor = parseFloat(wrapper.dataset.priceFloor) || 0;
        const ceil = parseFloat(wrapper.dataset.priceCeil) || 0;
        const symbol = wrapper.dataset.currencySymbol || '';
        if (!minInput || !maxInput || ceil <= floor) return;

        // values in cents
    const formatPrice = (cents, round) => {
      const _n = (round || Math.round)(cents / 100);
      const _e = String(_n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return (symbol || '€') + _e;
    };
const pct = (v) => ((v - floor) / (ceil - floor)) * 100;

        const refresh = (movedInput) => {
          let lo = parseInt(minInput.value, 10);
          let hi = parseInt(maxInput.value, 10);
          // step is 100 cents = 1 unit
          if (lo > hi - 100) {
            if (movedInput === minInput) {
              lo = Math.max(floor, hi - 100);
              minInput.value = lo;
            } else {
              hi = Math.min(ceil, lo + 100);
              maxInput.value = hi;
            }
          }
          minDisplay.textContent = formatPrice(lo, Math.floor);
          maxDisplay.textContent = formatPrice(hi, Math.ceil);
          if (minHidden) minHidden.value = Math.round(lo / 100);
          if (maxHidden) maxHidden.value = Math.round(hi / 100);
          if (fill) {
            fill.style.left = pct(lo) + '%';
            fill.style.right = (100 - pct(hi)) + '%';
          }
        };

        // make min input always above on left half, max above on right half
        // simpler: thumbs stay clickable because pointer-events is on thumb only
        minInput.addEventListener('input', () => {
          enableHidden();
          refresh(minInput);
        });
        maxInput.addEventListener('input', () => {
          enableHidden();
          refresh(maxInput);
        });

        const enableHidden = () => {
          if (minHidden) minHidden.disabled = false;
          if (maxHidden) maxHidden.disabled = false;
        };

        // initial paint
        refresh(null);
      });
    };

    window.__cfilterInit = init;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  /* ---- AJAX filtering (brand logos + sidebar filters + sort + pagination) ---- */
  (function () {
    const sectionSel = '[data-cfilter-section]';
    const scrollAnchor = () => document.querySelector(sectionSel);

    const navigate = async (url, opts = {}) => {
      const section = document.querySelector(sectionSel);
      if (!section) {
        window.location.href = url;
        return;
      }
      section.classList.add('is-loading');

      try {
        const res = await fetch(url, { headers: { 'Accept': 'text/html' } });
        if (!res.ok) throw new Error('fetch failed');
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newSection = doc.querySelector(sectionSel);
        if (!newSection) throw new Error('section not found');

        section.replaceWith(newSection);

        // Update brand strip (re-fetch active state, rebind marquee)
        const newBrandStrip = doc.querySelector('.section-brand-strip');
        const oldBrandStrip = document.querySelector('.section-brand-strip');
        if (newBrandStrip && oldBrandStrip) oldBrandStrip.replaceWith(newBrandStrip);

        // Re-initialize price slider on the new DOM
        if (typeof window.__cfilterInit === 'function') {
          window.__cfilterInit();
        }
        // Re-initialize brand strip marquee on the new DOM
        if (typeof window.__brandStripInit === 'function') {
          window.__brandStripInit();
        }

        // Push URL state
        window.history.pushState({}, '', url);

        if (opts.scroll !== false) {
          const anchor = scrollAnchor();
          if (anchor) {
            const top = anchor.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({ top, behavior: 'smooth' });
          }
        }
      } catch (err) {
        console.error('[cfilter] ajax navigation failed, falling back', err);
        window.location.href = url;
      } finally {
        const s = document.querySelector(sectionSel);
        if (s) s.classList.remove('is-loading');
      }
    };

    const handleClick = (e) => {
      // Brand logo click
      const brandLink = e.target.closest('.brand-logo[href]');
      if (brandLink) {
        const href = brandLink.getAttribute('href');
        if (href && href.indexOf('/collections/') === 0) {
          e.preventDefault();
          navigate(href);
          return;
        }
      }

      // Pagination links inside cfilter
      const pageLink = e.target.closest('[data-cfilter-section] .cfilter__page[href]');
      if (pageLink) {
        e.preventDefault();
        navigate(pageLink.getAttribute('href'));
        return;
      }

      // Reset link
      const resetLink = e.target.closest('[data-cfilter-section] .cfilter__reset');
      if (resetLink && resetLink.getAttribute('href')) {
        e.preventDefault();
        navigate(resetLink.getAttribute('href'));
        return;
      }
    };

    const handleSubmit = (e) => {
      const form = e.target.closest('#cfilter-form');
      if (!form) return;
      e.preventDefault();
      const formData = new FormData(form);
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        if (value !== '' && value != null) params.append(key, value);
      });
      const url = form.action || window.location.pathname;
      const finalUrl = url.split('?')[0] + '?' + params.toString();
      navigate(finalUrl);
    };

    const handlePopState = () => {
      navigate(window.location.href, { scroll: false });
    };

    document.addEventListener('click', handleClick);
    document.addEventListener('submit', handleSubmit);
    window.addEventListener('popstate', handlePopState);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    

  /* Street Ride : description de collection repliable */
  (function () {
    if (window.__srClampLoaded) return;
    window.__srClampLoaded = true;
    var init = function () {
      document.querySelectorAll('[data-sr-clamp]').forEach(function (el) {
        if (el.dataset.srClampBound) return;
        el.dataset.srClampBound = '1';
        var btn = el.nextElementSibling;
        if (!btn || !btn.hasAttribute('data-sr-clamp-toggle')) return;
        el.classList.add('is-clamped');
        if (el.scrollHeight > el.clientHeight + 4) {
          btn.hidden = false;
        } else {
          el.classList.remove('is-clamped');
        }
      });
    };
    window.__srClampInit = init;
    {
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-sr-clamp-toggle]');
        if (!btn) return;
        var el = btn.previousElementSibling;
        if (!el) return;
        var open = el.classList.toggle('is-clamped') === false;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? btn.dataset.less : btn.dataset.more;
      });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    if (window.MutationObserver) {
      var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(init, 60); }).observe(document.documentElement, { childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.currentScript.parentElement;
    const timer = root.querySelector('.countdown__timer');
    if (!timer) return;
    const targetStr = timer.getAttribute('data-countdown-target');
    if (!targetStr) return;
    const target = new Date(targetStr).getTime();
    if (Number.isNaN(target)) return;

    const slots = {
      d: timer.querySelector('[data-unit="d"]'),
      h: timer.querySelector('[data-unit="h"]'),
      m: timer.querySelector('[data-unit="m"]'),
      s: timer.querySelector('[data-unit="s"]'),
    };

    const pad = (n) => String(n).padStart(2, '0');

    const update = () => {
      const diff = target - Date.now();
      if (diff <= 0) {
        slots.d.textContent = '00';
        slots.h.textContent = '00';
        slots.m.textContent = '00';
        slots.s.textContent = '00';
        return false;
      }
      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const mins = Math.floor((diff % 3600000) / 60000);
      const secs = Math.floor((diff % 60000) / 1000);
      slots.d.textContent = pad(days);
      slots.h.textContent = pad(hours);
      slots.m.textContent = pad(mins);
      slots.s.textContent = pad(secs);
      return true;
    };

    if (update()) {
      const id = setInterval(() => {
        if (!update()) clearInterval(id);
      }, 1000);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const init = () => {
      const burger = document.querySelector('[data-header-open]');
      const drawer = document.querySelector('[data-header-drawer]');
      if (!burger || !drawer || drawer.dataset.bound) return;
      drawer.dataset.bound = '1';

      const closers = drawer.querySelectorAll('[data-header-close]');
      const open = () => {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        burger.setAttribute('aria-expanded', 'true');
      };
      const close = () => {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        burger.setAttribute('aria-expanded', 'false');
      };

      burger.addEventListener('click', open);
      closers.forEach((c) => c.addEventListener('click', close));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
      });

      const lang = document.querySelector('[data-header-lang]');
      if (lang && !lang.dataset.bound) {
        lang.dataset.bound = '1';
        document.addEventListener('click', (e) => {
          if (lang.open && !lang.contains(e.target)) lang.removeAttribute('open');
        });
      }

      // Predictive search panel
      const searchToggle = document.querySelector('[data-search-toggle]');
      const searchPanel = document.querySelector('[data-search-panel]');
      if (searchToggle && searchPanel && !searchPanel.dataset.bound) {
        searchPanel.dataset.bound = '1';

        const input = searchPanel.querySelector('[data-search-input]');
        const results = searchPanel.querySelector('[data-search-results]');
        const closeBtn = searchPanel.querySelector('[data-search-close]');
        const form = searchPanel.querySelector('[data-search-form]');
        const root = window.Shopify?.routes?.root || '/';

        const openPanel = () => {
          searchPanel.hidden = false;
          requestAnimationFrame(() => searchPanel.classList.add('is-open'));
          searchToggle.setAttribute('aria-expanded', 'true');
          setTimeout(() => input && input.focus(), 100);
        };
        const closePanel = () => {
          searchPanel.classList.remove('is-open');
          searchToggle.setAttribute('aria-expanded', 'false');
          setTimeout(() => { searchPanel.hidden = true; }, 250);
        };

        searchToggle.addEventListener('click', () => {
          if (searchPanel.classList.contains('is-open')) closePanel();
          else openPanel();
        });
        closeBtn.addEventListener('click', closePanel);
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && searchPanel.classList.contains('is-open')) closePanel();
        });
        document.addEventListener('click', (e) => {
          if (!searchPanel.classList.contains('is-open')) return;
          if (searchPanel.contains(e.target) || searchToggle.contains(e.target)) return;
          closePanel();
        });

    const formatMoney = (value, symbol) => {
      const v = typeof value === 'string' ? parseFloat(value) : value / 100;
      if (isNaN(v)) return '';
      const _p = v.toFixed(2).split('.');
      const _e = _p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return (symbol || '€') + _e + ',' + _p[1];
    };

        let debounceId;
        let abortCtrl;
        const fetchSuggest = async (q) => {
          if (q.length < 2) {
            results.hidden = true;
            results.innerHTML = '';
            return;
          }
          if (abortCtrl) abortCtrl.abort();
          abortCtrl = new AbortController();
          try {
            const url = `${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor`;
            const res = await fetch(url, { signal: abortCtrl.signal });
            const data = await res.json();
            renderResults(q, data.resources?.results?.products || []);
          } catch (err) {
            if (err.name !== 'AbortError') console.error(err);
          }
        };

        const renderResults = (q, products) => {
          results.hidden = false;
          if (products.length === 0) {
            results.innerHTML = '<p class="site-search__empty">' + (window.__searchNoResults || 'No results') + '</p>';
            return;
          }
          const symbol = window.__cartCurrency || '';
          const items = products.map((p) => {
            const img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
            const vendor = p.vendor ? '<span class="site-search__result-vendor">' + p.vendor + '</span>' : '';
            const price = p.price ? '<span class="site-search__result-price">' + formatMoney(p.price, symbol) + '</span>' : '';
            return `
              <a href="${p.url}" class="site-search__result">
                <img src="${img}" alt="" class="site-search__result-img" width="56" height="56" loading="lazy">
                <div class="site-search__result-info">
                  ${vendor}
                  <span class="site-search__result-title">${p.title}</span>
                </div>
                ${price}
              </a>`;
          }).join('');
          const seeAllLabel = window.__searchSeeAll || 'See all results';
          const seeAll = `<a href="${root}search?q=${encodeURIComponent(q)}&type=product" class="site-search__see-all">${seeAllLabel}</a>`;
          results.innerHTML = items + seeAll;
        };

        input.addEventListener('input', () => {
          clearTimeout(debounceId);
          const q = input.value.trim();
          if (q.length < 2) {
            results.hidden = true;
            results.innerHTML = '';
            return;
          }
          debounceId = setTimeout(() => fetchSuggest(q), 200);
        });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  /* ---- Cart drawer ---- */
  (function () {
    if (document.body.dataset.cartDrawerBound) return;
    document.body.dataset.cartDrawerBound = '1';

    const root = window.Shopify?.routes?.root || '/';
    const drawer = () => document.querySelector('[data-cart-drawer]');

    const openDrawer = () => {
      const d = drawer();
      if (!d) return;
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      const toggle = document.querySelector('[data-cart-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      // Always refresh content from the server when opening
      refreshDrawer();
    };
    const closeDrawer = () => {
      const d = drawer();
      if (!d) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      const toggle = document.querySelector('[data-cart-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    };

    const formatMoney = (cents) => {
      const symbol = (window.__cartCurrency || '').trim() || '€';
      const _p = (Math.round(cents) / 100).toFixed(2).split('.');
      const _e = _p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return symbol + _e + ',' + _p[1];
    };

    const updateHeaderCount = (count) => {
      const headerCart = document.querySelector('.site-header__cart');
      if (!headerCart) return;
      let counter = headerCart.querySelector('.site-header__cart-count');
      if (count > 0) {
        if (!counter) {
          counter = document.createElement('span');
          counter.className = 'site-header__cart-count';
          headerCart.appendChild(counter);
        }
        counter.textContent = count;
      } else if (counter) {
        counter.remove();
      }
    };

    const refreshDrawer = async () => {
      try {
        const res = await fetch(`${root}cart.js`, { headers: { 'Accept': 'application/json' } });
        const cart = await res.json();
        updateHeaderCount(cart.item_count);

        const d = drawer();
        if (!d) return;

        const countEl = d.querySelector('[data-cart-drawer-count]');
        const subtotalEl = d.querySelector('[data-cart-subtotal]');
        const foot = d.querySelector('[data-cart-drawer-foot]');
        const body = d.querySelector('[data-cart-drawer-body]');

        if (countEl) countEl.textContent = cart.item_count;
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

      if (window.srLivraisonPanier) window.srLivraisonPanier(cart.total_price, cart.item_count);

        if (cart.item_count === 0) {
          if (foot) foot.classList.add('is-hidden');
          if (body) {
            body.innerHTML = `
              <div class="cart-drawer__empty">
                <div class="cart-drawer__empty-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 4h2l2.5 12h11l2-8H6.5M9 20a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM18 20a1.5 1.5 0 100 3 1.5 1.5 0 000-3z" stroke-linecap="square"/></svg>
                </div>
                <p class="cart-drawer__empty-text">${window.__cartEmptyTitle || ''}</p>
                <button type="button" class="btn-ride btn-ride--outline" data-cart-close>
                  <span class="btn-ride__label">${window.__cartEmptyCta || ''}</span>
                </button>
              </div>
            `;
          }
          return;
        }

        if (foot) foot.classList.remove('is-hidden');

        // Rebuild the full list from cart data
        const escapeHtml = (s) => String(s || '')
          .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

        const formatVariant = (item) => {
          if (!item.options_with_values || item.product_has_only_default_variant) return '';
          const parts = item.options_with_values
            .filter((o) => o.value && o.value !== 'Default Title')
            .map((o) => escapeHtml(o.value));
          if (parts.length === 0) return '';
          return `<p class="cart-drawer-item__variant">${parts.join(' · ')}</p>`;
        };

        const imageFor = (item) => {
          if (item.featured_image && item.featured_image.url) return item.featured_image.url;
          if (item.image) return item.image;
          return '';
        };

        const itemHtml = (item) => {
          const img = imageFor(item);
          const imgTag = img
            ? `<img class="cart-drawer-item__img" src="${img}&width=200" srcset="${img}&width=100 100w, ${img}&width=150 150w, ${img}&width=200 200w" sizes="64px" alt="${escapeHtml(item.product_title || item.title)}" width="64" height="64" loading="lazy">`
            : '';
          return `
            <li class="cart-drawer-item" data-cart-drawer-item data-key="${escapeHtml(item.key)}">
              <a href="${item.url}" class="cart-drawer-item__media">${imgTag}</a>
              <div class="cart-drawer-item__body">
                <div class="cart-drawer-item__head">
                  <a href="${item.url}" class="cart-drawer-item__title">${escapeHtml(item.product_title || item.title)}</a>
                  <button type="button" class="cart-drawer-item__remove" data-cart-remove="${escapeHtml(item.key)}" aria-label="${escapeHtml(window.__cartRemoveLabel || 'Remove')}">
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke-linecap="square"/></svg>
                  </button>
                </div>
                ${formatVariant(item)}
                <div class="cart-drawer-item__foot">
                  <div class="cart-drawer-item__qty">
                    <button type="button" class="cart-drawer-item__qty-btn" data-cart-qty="-1" data-key="${escapeHtml(item.key)}" aria-label="−">−</button>
                    <input type="number" class="cart-drawer-item__qty-input" value="${item.quantity}" min="0" inputmode="numeric" pattern="[0-9]*" data-cart-qty-input data-key="${escapeHtml(item.key)}">
                    <button type="button" class="cart-drawer-item__qty-btn" data-cart-qty="1" data-key="${escapeHtml(item.key)}" aria-label="+">+</button>
                  </div>
                  <span class="cart-drawer-item__price" data-cart-line-price>${formatMoney(item.final_line_price)}</span>
                </div>
              </div>
            </li>
          `;
        };

        if (body) {
          body.innerHTML = `<ul class="cart-drawer__items" data-cart-drawer-items>${cart.items.map(itemHtml).join('')}</ul>`;
        }
      } catch (err) {
        console.error('[cart-drawer] refresh failed', err);
      }
    };

    const updateLine = async (key, quantity) => {
      const row = document.querySelector('[data-cart-drawer-item][data-key="' + CSS.escape(key) + '"]');
      if (row) row.classList.add('is-loading');
      try {
        const res = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity }),
        });
        const data = await res.json().catch(() => null);
        if (!res.ok) {
          const msg = (data && (data.description || data.message)) || 'cart change failed';
          console.error('[cart-drawer]', msg, data);
          // Revert qty input to true value from server
          await refreshDrawer();
          alert(msg);
          return;
        }
        await refreshDrawer();
      } catch (err) {
        console.error('[cart-drawer]', err);
      } finally {
        if (row) row.classList.remove('is-loading');
      }
    };

    const isOnCartPage = () => {
      const path = window.location.pathname.replace(/\/$/, '');
      return path === `${root}cart`.replace(/\/$/, '') || path.endsWith('/cart');
    };

    // Open via icon
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-cart-toggle]');
      if (toggle) {
        e.preventDefault();
        if (isOnCartPage()) {
          // Already on the cart page — just scroll to top instead of opening the drawer
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }
        const d = drawer();
        if (d && d.classList.contains('is-open')) closeDrawer();
        else openDrawer();
        return;
      }
      // Close via backdrop / close buttons
      const closeBtn = e.target.closest('[data-cart-close]');
      if (closeBtn) {
        closeDrawer();
        return;
      }
      // Qty +/-
      const qtyBtn = e.target.closest('[data-cart-qty]');
      if (qtyBtn) {
        e.preventDefault();
        const key = qtyBtn.getAttribute('data-key');
        const delta = parseInt(qtyBtn.getAttribute('data-cart-qty'), 10);
        const input = document.querySelector('[data-cart-qty-input][data-key="' + CSS.escape(key) + '"]');
        if (!input) return;
        const next = Math.max(0, (parseInt(input.value, 10) || 1) + delta);
        input.value = next;
        updateLine(key, next);
        return;
      }
      // Remove
      const removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        updateLine(removeBtn.getAttribute('data-cart-remove'), 0);
        return;
      }
    });

    document.addEventListener('change', (e) => {
      const input = e.target.closest('[data-cart-qty-input]');
      if (!input) return;
      const key = input.getAttribute('data-key');
      const next = Math.max(0, parseInt(input.value, 10) || 0);
      updateLine(key, next);
    });

    document.addEventListener('keydown', (e) => {
      const d = drawer();
      if (e.key === 'Escape' && d && d.classList.contains('is-open')) closeDrawer();
    });

    // Open drawer when a product is added from anywhere (e.g. PDP)
    document.addEventListener('streetride:cart-added', () => {
      if (isOnCartPage()) {
        // Just refresh the cart page to show new item — drawer would duplicate
        window.location.reload();
        return;
      }
      openDrawer();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const init = () => {
      const media = document.querySelector('[data-pdp-media]');
      const thumbs = document.querySelector('[data-pdp-thumbs]');
      if (media && thumbs && !media.dataset.bound) {
        media.dataset.bound = '1';
        thumbs.querySelectorAll('[data-pdp-thumb]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const idx = btn.getAttribute('data-pdp-thumb');
            media.querySelectorAll('[data-pdp-slide]').forEach((s) => {
              s.classList.toggle('is-active', s.getAttribute('data-pdp-slide') === idx);
            });
            thumbs.querySelectorAll('[data-pdp-thumb]').forEach((t) => {
              t.classList.toggle('is-active', t === btn);
            });
          });
        });
      }

      const qtyInput = document.querySelector('[data-pdp-qty-input]');
      if (qtyInput && !qtyInput.dataset.bound) {
        qtyInput.dataset.bound = '1';
        document.querySelectorAll('[data-pdp-qty]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const delta = parseInt(btn.getAttribute('data-pdp-qty'), 10);
            const next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
            qtyInput.value = next;
          });
        });
      }

      const form = document.querySelector('[data-pdp-form]');
      const variantInput = document.querySelector('[data-pdp-variant-id]');
      const priceEl = document.querySelector('[data-pdp-price]');
      const stickyPriceEl = document.querySelector('[data-pdp-sticky-price]');
      const atcBtn = document.querySelector('.pdp__atc');

      if (form && variantInput && !form.dataset.bound) {
        form.dataset.bound = '1';

        const productData = window.__pdpProduct;
        if (productData) {
        const formatMoney = (cents) => {
          const _p = (Math.round(cents) / 100).toFixed(2).split('.');
          const _e = _p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          return (productData.currency_symbol || '€') + _e + ',' + _p[1];
        };

          const updateFromInputs = (changed) => {
            const inputs = form.querySelectorAll('[data-pdp-option-input]:checked');
            const values = Array.from(inputs).map((i) => i.value);
            let variant = productData.variants.find((v) =>
              v.options.length === values.length && v.options.every((o, i) => o === values[i])
            );
            // Street Ride : combinaison inexistante (ex. couleur dispo dans une seule taille) : on prend la variante de la valeur cliquée et on cale les autres options dessus
            if (!variant && changed) {
              const grp = changed.closest('[data-pdp-option-group]');
              const idx = grp ? parseInt(grp.getAttribute('data-pdp-option-group'), 10) : -1;
              if (idx >= 0) {
                const cands = productData.variants.filter((v) => v.options[idx] === changed.value);
                variant = cands.find((v) => v.available) || cands[0];
                if (variant) variant.options.forEach((o, i) => {
                  const g = form.querySelector('[data-pdp-option-group="' + i + '"]');
                  const inp = g && Array.from(g.querySelectorAll('[data-pdp-option-input]')).find((x) => x.value === o);
                  if (inp && !inp.checked) inp.checked = true;
                });
              }
            }
            if (!variant) return;
            variantInput.value = variant.id;
            var _vm = variant.featured_media;
            if (_vm && _vm.id != null) { var _mid = String(_vm.id); media.querySelectorAll('[data-pdp-slide]').forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-pdp-media-id') === _mid); }); if (thumbs) thumbs.querySelectorAll('[data-pdp-thumb]').forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-pdp-media-id') === _mid); }); }

            form.querySelectorAll('[data-pdp-option-selected]').forEach((el) => {
              const idx = parseInt(el.getAttribute('data-pdp-option-selected'), 10);
              if (variant.options[idx]) el.textContent = variant.options[idx];
            });

            if (priceEl) {
              const current = priceEl.querySelector('.pdp__price-current');
              const compare = priceEl.querySelector('.pdp__price-compare');
              const saving = priceEl.querySelector('.pdp__price-saving');
              if (current) current.textContent = formatMoney(variant.price);
              const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
              if (current) current.classList.toggle('pdp__price-current--sale', onSale);
              if (compare) {
                compare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
                compare.style.display = onSale ? '' : 'none';
              }
              if (saving) {
                if (onSale) {
                  const pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
                  saving.textContent = '-' + pct + '%';
                  saving.style.display = '';
                } else {
                  saving.style.display = 'none';
                }
              }
            }
            if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(variant.price);

            if (atcBtn) atcBtn.disabled = !variant.available;

            const stockEl = document.querySelector('[data-pdp-stock]');
            if (stockEl && productData.stock_labels) {
              const labels = productData.stock_labels;
              let status = 'in_stock';
              if (!variant.available) status = 'sold_out';
              else if (variant.preorder) status = 'backorder';

              stockEl.className = 'pdp__stock pdp__stock--' + status;
              const labelSpan = stockEl.querySelector('span');
              if (labelSpan) labelSpan.textContent = labels[status] || '';
            }
          };

          form.addEventListener('change', (e) => {
            if (e.target.matches('[data-pdp-option-input]')) updateFromInputs(e.target);
          });
          updateFromInputs(); // init: synchro image/variante au chargement
        }
      }

      // AJAX add-to-cart → open cart drawer
      const atcForm = document.querySelector('#pdp-form');
      if (atcForm && !atcForm.dataset.ajaxBound) {
        atcForm.dataset.ajaxBound = '1';

        const atcButtons = document.querySelectorAll('[data-pdp-atc], .pdp-sticky__cta');
        const root = window.Shopify?.routes?.root || '/';

        atcForm.addEventListener('submit', async (e) => {
          e.preventDefault();
          const submitBtns = Array.from(atcButtons).filter((b) => !b.disabled);
          submitBtns.forEach((b) => b.classList.add('is-loading'));

          try {
            const formData = new FormData(atcForm);
            const addRes = await fetch(`${root}cart/add.js`, {
              method: 'POST',
              headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: formData,
            });

            if (!addRes.ok) {
              const err = await addRes.json().catch(() => ({}));
              alert(err.description || err.message || (function (l) { return l.indexOf('nl') === 0 ? 'Er ging iets mis. Probeer het opnieuw.' : l.indexOf('de') === 0 ? 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.' : l.indexOf('es') === 0 ? 'Se ha producido un error. Inténtalo de nuevo.' : l.indexOf('pt') === 0 ? 'Ocorreu um erro. Tente novamente.' : l.indexOf('it') === 0 ? 'Si è verificato un errore. Riprova.' : l.indexOf('en') === 0 ? 'Something went wrong. Please try again.' : 'Erreur. Réessayez.'; })(document.documentElement.lang || ''));
              return;
            }

            // Notify other modules (header cart drawer, count badge…) to refresh
            document.dispatchEvent(new CustomEvent('streetride:cart-added'));
          } catch (err) {
            console.error(err);
            alert((function (l) { return l.indexOf('nl') === 0 ? 'Netwerkfout. Probeer het opnieuw.' : l.indexOf('de') === 0 ? 'Netzwerkfehler. Bitte versuchen Sie es erneut.' : l.indexOf('es') === 0 ? 'Error de red. Inténtalo de nuevo.' : l.indexOf('pt') === 0 ? 'Erro de rede. Tente novamente.' : l.indexOf('it') === 0 ? 'Errore di rete. Riprova.' : l.indexOf('en') === 0 ? 'Network error. Please try again.' : 'Erreur réseau. Réessayez.'; })(document.documentElement.lang || ''));
          } finally {
            submitBtns.forEach((b) => b.classList.remove('is-loading'));
          }
        });
      }

      // Lightbox
      const lightbox = document.querySelector('[data-pdp-lightbox]');
      if (lightbox && !lightbox.dataset.bound) {
        lightbox.dataset.bound = '1';
        const zoomButtons = document.querySelectorAll('[data-pdp-zoom]');
        const lbClose = lightbox.querySelectorAll('[data-pdp-lightbox-close]');
        const lbPrev = lightbox.querySelector('[data-pdp-lightbox-prev]');
        const lbNext = lightbox.querySelector('[data-pdp-lightbox-next]');
        const lbSlides = lightbox.querySelectorAll('[data-pdp-lightbox-slide]');
        const lbCurrent = lightbox.querySelector('[data-pdp-lightbox-current]');
        const total = lbSlides.length;
        let activeIndex = 0;

        const showSlide = (idx) => {
          if (total === 0) return;
          activeIndex = ((idx % total) + total) % total;
          lbSlides.forEach((s) => {
            const i = parseInt(s.getAttribute('data-pdp-lightbox-slide'), 10);
            s.classList.toggle('is-active', i === activeIndex);
          });
          if (lbCurrent) lbCurrent.textContent = activeIndex + 1;
        };

        const openLightbox = (startIdx) => {
          showSlide(startIdx);
          if (typeof lightbox.showModal === 'function') lightbox.showModal();
          else lightbox.setAttribute('open', '');
        };
        const closeLightbox = () => {
          if (typeof lightbox.close === 'function') lightbox.close();
          else lightbox.removeAttribute('open');
        };

        zoomButtons.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            const idx = parseInt(btn.getAttribute('data-pdp-zoom'), 10) || 0;
            // Only count image slides — videos are skipped in lightbox markup,
            // so we need to find the matching image slide if videos exist before it.
            // Simplification: use the data-pdp-zoom index directly. If a video is
            // before in the order, this index won't match; we map by image-only order:
            const targetSlide = lightbox.querySelector('[data-pdp-lightbox-slide="' + idx + '"]');
            if (targetSlide) {
              openLightbox(idx);
            } else {
              // image was filtered out somehow — open first
              openLightbox(0);
            }
          });
        });

        lbClose.forEach((b) => b.addEventListener('click', closeLightbox));
        lightbox.addEventListener('click', (e) => {
          if (e.target === lightbox) closeLightbox();
        });

        if (lbPrev) lbPrev.addEventListener('click', () => showSlide(activeIndex - 1));
        if (lbNext) lbNext.addEventListener('click', () => showSlide(activeIndex + 1));

        document.addEventListener('keydown', (e) => {
          if (!lightbox.open) return;
          if (e.key === 'ArrowLeft') showSlide(activeIndex - 1);
          if (e.key === 'ArrowRight') showSlide(activeIndex + 1);
        });

        // Swipe gestures
        let touchStartX = 0;
        let touchStartY = 0;
        lightbox.addEventListener('touchstart', (e) => {
          if (e.touches.length !== 1) return;
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        }, { passive: true });
        lightbox.addEventListener('touchend', (e) => {
          if (!touchStartX) return;
          const dx = e.changedTouches[0].clientX - touchStartX;
          const dy = e.changedTouches[0].clientY - touchStartY;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
            if (dx < 0) showSlide(activeIndex + 1);
            else showSlide(activeIndex - 1);
          }
          touchStartX = 0;
          touchStartY = 0;
        }, { passive: true });
      }

      const sticky = document.querySelector('[data-pdp-sticky]');
      const heroAtc = document.querySelector('.pdp__atc');
      if (sticky && heroAtc && !sticky.dataset.bound) {
        sticky.dataset.bound = '1';
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const visible = !entry.isIntersecting;
            sticky.classList.toggle('is-visible', visible);
            sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
          });
        }, { rootMargin: '0px 0px -100px 0px', threshold: 0 });
        io.observe(heroAtc);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const init = () => {
      const select = document.querySelector('[data-search-sort]');
      if (!select || select.dataset.bound) return;
      select.dataset.bound = '1';
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        window.location.href = url.toString();
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
